export default "__VITE_ASSET__DJcYbMfT__"